export const NAME = 'incidents';

export const UPDATE_INCIDENTS = 'UPDATE_INCIDENTS';

const pageID = 'hd7xgwkyb9j3';
export const baseRoute = `https://api.statuspage.io/v1/pages/${pageID}`;
